// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mandate_container_surveys_landing__S4moH {
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
 }

  .mandate_sections_definitions__iCu8S{
    flex-direction: row;
    align-items: center;
  align-content: center;
  justify-content: center;
  }

  .mandate_sections_mandates__xu5zd{
    flex-direction: column;
    align-items: center;
  align-content: center;
  justify-content: center;
  }

    .mandate_sections_definitions_left__Z4ss7{
    flex-direction: column;
    width: 50%;
    align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  }
      .mandate_sections_definitions_right__ZVhOv{
    flex-direction: column;
    width: 50%;
    align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/pages/Mandate/mandate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;CACd;;EAEC;IACE,mBAAmB;IACnB,mBAAmB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB;;IAEE;IACA,sBAAsB;IACtB,UAAU;IACV,uBAAuB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB;MACI;IACF,sBAAsB;IACtB,UAAU;IACV,uBAAuB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB","sourcesContent":[".container_surveys_landing {\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n }\r\n\r\n  .sections_definitions{\r\n    flex-direction: row;\r\n    align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  }\r\n\r\n  .sections_mandates{\r\n    flex-direction: column;\r\n    align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  }\r\n\r\n    .sections_definitions_left{\r\n    flex-direction: column;\r\n    width: 50%;\r\n    align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: center;\r\n  }\r\n      .sections_definitions_right{\r\n    flex-direction: column;\r\n    width: 50%;\r\n    align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: center;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_surveys_landing": `mandate_container_surveys_landing__S4moH`,
	"sections_definitions": `mandate_sections_definitions__iCu8S`,
	"sections_mandates": `mandate_sections_mandates__xu5zd`,
	"sections_definitions_left": `mandate_sections_definitions_left__Z4ss7`,
	"sections_definitions_right": `mandate_sections_definitions_right__ZVhOv`
};
export default ___CSS_LOADER_EXPORT___;
